@let section = sectionService.section();
@if (section && sectionService.visible()) {
  <div
    class="flex !w-full flex-col gap-2 overflow-hidden rounded-2xl border border-gray-200 bg-white"
  >
    <div
      [pTooltip]="section.customization.description"
      class="flex flex-row items-center justify-between gap-2 px-5 pb-4 pt-3"
    >
      <div class="flex flex-col gap-1">
        <div class="text-lg font-bold">{{ section.customization.title }}</div>
        <div class="text-sm">{{ section.customization.subTitle }}</div>
      </div>
      <div class="flex flex-col items-center gap-1">
        <div class="w-16 text-end text-lg font-bold">
          {{ section.customization.points }} pt
        </div>
      </div>
    </div>

    <div class="border-accent-300 mx-4 flex flex-1 border-t-[1px]"></div>
    <div class="flex w-full flex-col">
      @for (subsection of section.children; track subsection; let i = $index) {
        <lib-compiled-sub-section [uniqueId]="subsection" />
      }
    </div>
  </div>
}
